// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CtaBlock_wrapper__1Ltsd"};